// Data for phone dialer

export interface DialerKey {
  textColor?: string;
  backgroundColor?: string;
  key: string;
  characters: string;
}

export const KEYPAD_DATA: DialerKey[] = [
  {
    key: '1',
    characters: '',
  },
  {
    key: '2',
    characters: 'ABC',
  },
  {
    key: '3',
    characters: 'DEF',
  },
  {
    key: '4',
    characters: 'GHI',
  },
  {
    key: '5',
    characters: 'JKL',
  },
  {
    key: '6',
    characters: 'MNO',
  },
  {
    key: '7',
    characters: 'PQRS',
  },
  {
    key: '8',
    characters: 'TUV',
  },
  {
    key: '9',
    characters: 'WXYZ',
  },
  {
    key: '*',
    characters: '',
    backgroundColor: 'rgba(172, 173, 179, 0.68)',
  },
  {
    key: '0',
    characters: '',
  },
  {
    key: '#',
    characters: '',
    backgroundColor: 'rgba(172, 173, 179, 0.68)',
  },
];

export const phoneValidationRegex = new RegExp(/^[0-9\b]+$/);

export const DEFAULT_POLL_INTERVAL = 5 * 60 * 1000; // every 5 minutes;
